export const waitFor = (millis: number) =>
  new Promise<void>(resolve => {
    setTimeout(resolve, millis)
  })
